var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "schedule_black_24dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-details",
    transform: "translate(-1038.000000, -343.000000)",
    fillRule: "nonzero",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1022.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "schedule_black_24dp",
    transform: "translate(16.000000, 189.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.991,0 C4.023,0 0,4.032 0,9 C0,13.968 4.023,18 8.991,18 C13.968,18 18,13.968 18,9 C18,4.032 13.968,0 8.991,0 Z M9,16.2 C5.022,16.2 1.8,12.978 1.8,9 C1.8,5.022 5.022,1.8 9,1.8 C12.978,1.8 16.2,5.022 16.2,9 C16.2,12.978 12.978,16.2 9,16.2 Z M9.45,4.5 L8.1,4.5 L8.1,9.9 L12.825,12.735 L13.5,11.628 L9.45,9.225 L9.45,4.5 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleBlack24Dp);
export default __webpack_public_path__ + "static/media/schedule_black_24dp.563cbceaeef333f8838f8805f2c4cfc5.svg";
export { ForwardRef as ReactComponent };